import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { NavService } from "../../../../../../../shared/src/lib/services/nav.service";
import { Router, RouterLink } from "@angular/router";
import { ApiService } from "../../../../../../../shared/src";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { ChangePasswordComponent } from "../../../../pages/user-pages/change-password/change-password.component";
import { LanguageSelectorComponent } from "../../../../pages/user-pages/language-selector/language-selector.component";
import { MatDialog } from "@angular/material/dialog";
import { WalletTransferComponent } from "../wallet-transfer/wallet-transfer.component";

@Component({
  selector: "app-user-button",
  imports: [RouterLink, MatMenuModule, MatIconModule, MatButtonModule, TranslateModule],
  templateUrl: "./user-button.component.html",
  styleUrl: "./user-button.component.scss",
})
export class UserButtonComponent implements OnInit, OnDestroy {
  apiService = inject(ApiService);
  navService = inject(NavService);
  router = inject(Router);
  bottomSheet = inject(MatBottomSheet);
  user: any = null;
  readonly dialog = inject(MatDialog);

  get userName() {
    const user = this.apiService.getUserToken();
    return user?.user?.NAME;
  }

  ngOnInit() {
    const app = this.apiService.getUserToken();
    this.user = app.user;
  }

  ngOnDestroy() {
    this.dialog.closeAll();
  }

  canShowItem(item: any): boolean {
    if (item.name === "Change Password") {
      return !this.userName.includes("demo");
    }
    return true;
  }

  handleNonRouteItems(name: string) {
    if (name === "Transfer Wallet") {
      this.handleWalletTransfer();
    } else if (name === "Change Password") {
      this.handleChangePassword();
    } else if (name === "Select Language") {
      this.handleSelectLanguage();
    } else if (name === "Sign Out") {
      this.apiService.handleSignOut();
    }
  }

  handleSelectLanguage() {
    this.bottomSheet.open(LanguageSelectorComponent);
  }

  handleChangePassword() {
    this.bottomSheet
      .open(ChangePasswordComponent)
      .afterDismissed()
      .subscribe((result) => {
        if (result) this.apiService.handleSignOut();
      });
  }

  handleWalletTransfer() {
    this.dialog.open(WalletTransferComponent);
  }
}
